import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'CheckIcon',
  viewBox: '0 0 16 16',
  path: (
    <path
      fill="currentColor"
      d="M12.53 3.152a1 1 0 0 1 .318 1.378l-4.997 8a1 1 0 0 1-1.647.07L3.2 8.604A1 1 0 0 1 4.8 7.4l2.127 2.833 4.225-6.764a1 1 0 0 1 1.378-.318"
    />
  ),
});
